import * as yup from 'yup'

export const columnSchema = yup
  .object()
  .shape({
    columns: yup
      .array()
      .of(yup.string())
      .min(1, 'Please select at least one column.'),
    isEditor: yup.boolean(),
  })
  .required()
